import { createContext } from "react";
export const TestingModeContext = createContext(false);
export const GameIndexContext = createContext(0);
//# sourceMappingURL=Context.js.map